import React from "react";
import NegPegPie from "../../images/svg/neg-peg-pie.svg";
import NegPegPieRebrand from "../../images/rebrand/svg/neg-peg-pie.svg";
import PosPegPie from "../../images/svg/peg-star.svg";
import { useFlags } from 'launchdarkly-react-client-sdk';

var PegPie = function PegPie(_ref) {
  var number = _ref.number;
  var numberIsPos = number > 0;
  var flags = useFlags();
  var useNewRebrandStyles = flags['releaseRebrandDstr6457'] || false;
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-peg-pie"
  }, /*#__PURE__*/React.createElement("img", {
    className: "cb-peg-pie__pie",
    src: numberIsPos ? PosPegPie : useNewRebrandStyles ? NegPegPieRebrand : NegPegPie,
    alt: "Sum of pegs redeemed or earned"
  }), /*#__PURE__*/React.createElement("div", {
    className: "cb-peg-pie__text ".concat(numberIsPos ? 'pos' : "")
  }, numberIsPos ? "+".concat(number) : "".concat(number)));
};

export default PegPie;